import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'
import Detail from '@/pages/Detail'
import Detail2 from '@/pages/Detail2'
import Buy from '@/pages/Buy'
import Order from '@/pages/Order'
import Success from '@/pages/Success'
import AboutUs from '@/pages/AboutUs'
import ConcatUs from '@/pages/ConcatUs'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },{
      path: '/detail/:id',
      name: 'Detail',
      component: Detail
    },{
      path: '/detail2/:id',
      name: 'Detail2',
      component: Detail2
    },
    {
      path: '/buy',
      name: 'Buy',
      component: Buy
    },
    {
      path: '/order',
      name: 'Order',
      component: Order
    },
    {
      path: '/success',
      name: 'Success',
      component: Success
    },
    {
      path: '/aboutUs',
      name: 'AboutUs',
      component: AboutUs
    },
    {
      path: '/concatUs',
      name: 'ConcatUs',
      component: ConcatUs
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js